// Live loudness of a mic stream, for the recording waveform. Reads the
// waveform's RMS and scales it so normal speech fills most of the 0..1 range.

const GAIN = 4;

export interface ILevelMeter {
  read: () => number;
  close: () => void;
}

/** Null where the browser has no Web Audio; the waveform then stays flat. */
export function createLevelMeter(stream: MediaStream): ILevelMeter | null {
  if (typeof AudioContext === 'undefined') return null;
  const context = new AudioContext();
  // Made after the mic prompt, outside the click, so some browsers start it suspended (reads as silence).
  void context.resume();
  const analyser = context.createAnalyser();
  analyser.fftSize = 512;
  context.createMediaStreamSource(stream).connect(analyser);
  const samples = new Uint8Array(analyser.fftSize);

  return {
    read() {
      analyser.getByteTimeDomainData(samples);
      let sum = 0;
      for (const s of samples) {
        const centered = (s - 128) / 128;
        sum += centered * centered;
      }
      return Math.min(1, Math.sqrt(sum / samples.length) * GAIN);
    },
    close() {
      void context.close();
    },
  };
}
